export const catalogOptions = [
    {
        label: "视光渠道",
        value: "视光渠道",
    },
    {
        label: "医疗渠道",
        value: "医疗渠道",
    },
    {
        label: "教育渠道",
        value: "教育渠道",
    },
];

export const aboutCatalogOptions = [
    {
        label: "相关信息",
        value: "相关信息"
    }
];

export const aboutType = '相关信息';

export const allCatalogOptions = [
    ...catalogOptions,
    ...aboutCatalogOptions,
];

export const aboutProductOptions = [
    {
        label: "视光相关信息",
        value: "视光相关信息",
    },
    {
        label: "医疗相关信息",
        value: "医疗相关信息",
    },
    {
        label: "教育相关信息",
        value: "教育相关信息",
    },

];

export const getCopyLink = (record) => {
    const path = '#/branddetails';
    const { origin, pathname } = window.location;
    return `${origin}${pathname}${path}?id=${record.id}`;
};
